import {
  PDFEDITOR_ON_CHECK_TOTAL_SECTIONS_HEIGHT,
  PDFEDITOR_ON_NAME_CHANGE,
  PDFEDITOR_ON_TYPE_CHANGE,
  PDFEDITOR_ON_CATEGORY_CHANGE,

  PDFEDITOR_ON_ADD_PAGE,
  PDFEDITOR_ON_ADD_SECTION,
  // PDFEDITOR_ON_ADD_COLUMN,

  PDFEDITOR_ON_DELETE_PAGE,
  PDFEDITOR_ON_DELETE_SECTION,
  // PDFEDITOR_ON_DELETE_COLUMN,

  PDFEDITOR_ON_SELECT_PAGE,
  PDFEDITOR_ON_SELECT_SECTION,
  PDFEDITOR_ON_SELECT_COLUMN,
  PDFEDITOR_ON_SELECT_TABLE_CELL,
  PDFEDITOR_ON_SELECT_PRODUCT_HEADER,

  PDFEDITOR_ON_UPDATE_PAGE,
  PDFEDITOR_ON_UPDATE_SECTION,
  PDFEDITOR_ON_UPDATE_COLUMN,
  PDFEDITOR_ON_UPDATE_TABLE_CELL,
  PDFEDITOR_ON_UPDATE_TABLE_CELL_WIDTH,
  PDFEDITOR_ON_UPDATE_TABLE_ROW_PADDING,
  PDFEDITOR_ON_UPDATE_PRODUCT_HEADER,

  PDFEDITOR_ON_ADD_TEMPLATE,
  PDFEDITOR_ON_DELETE_TEMPLATE,
  PDFEDITOR_ON_UPDATE_TEMPLATE,
  PDFEDITOR_ON_GET_TEMPLATES,
  PDFEDITOR_ON_LOAD_TEMPLATE,
  PDFEDITOR_ON_MOVE_SECTION,
  PDFEDITOR_ON_MOVE_SECTION_FROM_PAGE,
  PDFEDITOR_ON_MOVE_PAGE,

  PDFEDITOR_ON_GEN_TEMPID,
  PDFEDITOR_ON_SET_NEW_TEMP,
  PDFEDITOR_ON_LOAD_IMAGE_GALLERY,
  PDFEDITOR_ON_MENU_TAB_CHANGE,
  PDFEDITOR_ON_RESPOSE,
  PDFEDITOR_ON_RESPOSE_RESET,


}  from '../constants/ActionTypes'

import axios from 'util/Api' 
import {isEmpty } from 'lodash'
import {history} from 'store'
import { v4 as uuidv4 } from 'uuid';

const checkPageSectionsTotalHeight = () => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_CHECK_TOTAL_SECTIONS_HEIGHT})
  }
}

export const moveSection = (hindex, dindex, page) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_MOVE_SECTION, payload: {hindex, dindex, page}})
  }
}
export const moveSectionFromPage = (section, tpage,fpage) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_MOVE_SECTION_FROM_PAGE, payload: {section, tpage,fpage}})
  }
}
export const changeName = (name) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_NAME_CHANGE, payload: name})
  }
}
export const changeType = (type) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_TYPE_CHANGE, payload: type})
  }
}
export const changeCategory = (category) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_CATEGORY_CHANGE, payload: category})
  }
}

export const addPage = (page, dflag) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_ADD_PAGE, payload: {page, dflag}})
    dispatch(checkPageSectionsTotalHeight())
  }
}
export const addSection = (page) => {
  return async (dispatch) => {
    await dispatch({type: PDFEDITOR_ON_ADD_SECTION, payload: page})
    await dispatch(checkPageSectionsTotalHeight())
  }
}


export const selectPage = (page) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_SELECT_PAGE, payload: page})
  }
}
export const selectSection = (section) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_SELECT_SECTION, payload: section})
  }
}
export const selectColumn = (column, section) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_SELECT_COLUMN, payload: {column, section}})
  }
}
export const selectTableCell = (row, cell) => {
  return (dispatch => {
    dispatch({type: PDFEDITOR_ON_SELECT_TABLE_CELL, payload: {row, cell}})
  })
}
export const selectProductHeader = (header) => {
  return (dispatch => {
    dispatch({type: PDFEDITOR_ON_SELECT_PRODUCT_HEADER, payload: header})
  })
}


export const deletePage = (page) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_DELETE_PAGE, payload: page})
  }
}
export const movePage = (page, direction, index) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_MOVE_PAGE, payload: {page, direction, index}})
  }
}
export const deleteSection = (section) => {
  return async (dispatch) => {
    await dispatch({type: PDFEDITOR_ON_DELETE_SECTION, payload: section})
    await dispatch(checkPageSectionsTotalHeight())
  }
}


export const updatePage = (page) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_UPDATE_PAGE, payload: page})
    dispatch(checkPageSectionsTotalHeight())
  }
}
export const updateSection = (section) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_UPDATE_SECTION, payload: section})
    dispatch(checkPageSectionsTotalHeight())
  }
}
export const updateColumn = (column) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_UPDATE_COLUMN, payload: column})
    dispatch(checkPageSectionsTotalHeight())
  }
}
export const updateTableCell = (rowId, cell) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_UPDATE_TABLE_CELL, payload:{rowId, cell}})
    dispatch(checkPageSectionsTotalHeight())
  }
}
export const updateTableCellWidth = (rowId, cell, width) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_UPDATE_TABLE_CELL_WIDTH, payload:{rowId, cell, width}})
    dispatch(checkPageSectionsTotalHeight())
  }
}
export const updateTableRowPadding = (rowId, cell, padding) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_UPDATE_TABLE_ROW_PADDING, payload:{rowId, cell, padding}})
    dispatch(checkPageSectionsTotalHeight())
  }
}
export const updateProductHeader = (header) => {
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_UPDATE_PRODUCT_HEADER, payload: header})
    dispatch(checkPageSectionsTotalHeight())
  }
}

//Api requests
export const addTemplate = (template) => {
  let deselectedPages = []
  template.Pages.map(p => {
    let deselectedSections = [] 
    p.sections.map(s => {
      let deselectedColumns = []
      s.col.map(c => {
        deselectedColumns.push({
          ...c,
          selected: false
        })
      })
      deselectedSections.push({
        ...s,
        col: deselectedColumns,
        selected: false
      })
    })
    deselectedPages.push({
      ...p,
      sections: deselectedSections,
      selected: false
    })
  })
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    var _pages = new Blob([JSON.stringify(deselectedPages)], { type: 'application/json', endings: 'native' });
    const formData = new FormData()
    
    formData.append('files[]', _pages);
    formData.append('AfId', template.Afid);
    formData.append('UserId', template.Userid);
    formData.append('Orgnr', parseInt(template.Orgnr));
    formData.append('Namn', template.Namn);
    formData.append('Kategori', template.Kategori);
    formData.append('Typ', template.Typ);
    formData.append('TempId', template.Tempid);

    axios.post('pdfEditor/add', 
      formData,
        {
        body: {
          AfId: template.Afid,
          UserId: template.Userid,
          Orgnr: parseInt(template.Orgnr),
          Namn: template.Namn,
          Kategori: template.Kategori,
          Typ: template.Typ,
          TempId: template.Tempid,
        },
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
      ).then(({data}) => {
        if(data.success) {
          dispatch({type: PDFEDITOR_ON_ADD_TEMPLATE, payload: data})
          dispatch({type: PDFEDITOR_ON_RESPOSE, payload: {success: true, msg: 'Mall skapad!', show: true, type: 'success', class: 'text-white bg-success'}})
          history.push({
            pathname: '/app/Konto/Mall/'+ template.Tempid
          })
        } else {
          dispatch({type: PDFEDITOR_ON_RESPOSE, payload: {success: false, msg: 'Kunde inte skapa mall!', show: true, type: 'error', class: 'text-white bg-danger'}})
        }
    }).catch(err => {
      dispatch({type: PDFEDITOR_ON_RESPOSE, payload: {success: false, msg: 'Mall ej skapad!', show: true, type: 'error', class: 'text-white bg-danger'}})
      console.log(err)
    })
  }
}

export const deleteTemplate = (id, afId) => {
  return (dispatch) => {
    
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('pdfEditor/delete', { params:{id}, headers: {'Authorization':   `Bearer ${jwt}`}}).then(({data}) => {
      console.log(data)
      dispatch({type: PDFEDITOR_ON_DELETE_TEMPLATE, payload: data})
      dispatch({type: PDFEDITOR_ON_RESPOSE, payload: {success: true, msg: 'Mall #'+id+' borttagen!', show: true, type: 'warning', class: 'text-white bg-warning'}})
      dispatch(getTemplates(afId))
    }).catch(err => {
      dispatch({type: PDFEDITOR_ON_RESPOSE, payload: {success: false, msg: 'Kunde inte ta bort Mall #'+id, show: true, type: 'error', class: 'text-white bg-danger'}})
      console.log(err)
    })
  }
}
export const updateTemplateByMeta = (Afid, TempId, Meta, Value) => {
  return (dispatch) => {
    
    const jwt =  JSON.parse(localStorage.token);

    axios.put('pdfEditor/updateByMeta', 
        {
        body: {
          TempId, Meta,Value
        }
      },{
        headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
        }
      }
      ).then(({data}) => {
        console.log(data)
        if(data.success) dispatch(getTemplates(Afid))
    }).catch(err => {
      console.log(err)
    })
  }
}

export const updateTemplate = (id, pages, name, type, category) => {
  let deselectedPages = []
  pages.map(p => {
    let deselectedSections = [] 
    p.sections.map(s => {
      let deselectedColumns = []
      s.col.map(c => {
        deselectedColumns.push({
          ...c,
          selected: false
        })
      })
      deselectedSections.push({
        ...s,
        col: deselectedColumns,
        selected: false
      })
    })
    deselectedPages.push({
      ...p,
      sections: deselectedSections,
      selected: false
    })
  })

  return (dispatch) => {
    
    const jwt =  JSON.parse(localStorage.token);
    var _pages = new Blob([JSON.stringify(deselectedPages)], { type: 'application/json', endings: 'native' });
    const formData = new FormData()
    
    formData.append('files[]', _pages);
    formData.append('id', id);
    formData.append('Name', name);
    formData.append('Type', isEmpty(type)?"Övrigt":type);
    formData.append('Category', category);

    axios.put('pdfEditor/update', 
      formData,
        {
        body: {
          id: id, 
          Name: name,
          Type: isEmpty(type)?"Övrigt":type,
          Category: category
        },
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
      ).then(({data}) => {
      if(data.success){
        dispatch({type: PDFEDITOR_ON_UPDATE_TEMPLATE, payload: data})
        dispatch({type: PDFEDITOR_ON_RESPOSE, payload: {success: true, msg: 'Mall sparad!', show: true, type: 'success'}})
      } else {
        console.log(data)
        dispatch({type: PDFEDITOR_ON_RESPOSE, payload: {success: false, msg: 'Kunde inte spara mall!', show: true, type: 'error'}})
      }
    }).catch(err => {
      dispatch({type: PDFEDITOR_ON_RESPOSE, payload: {success: false, msg: 'Mall ej sparad!', show: true, type: 'error'}})
    })
  }
}

export const getTemplates = (afId) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('pdfEditor/get', { params:{AfId: afId},headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } }).then(({data}) => {
      dispatch({type: PDFEDITOR_ON_GET_TEMPLATES, payload: data})
    }).catch(err => {
      console.log(err)
    })
  }
}

export const loadTemplate = (templateId, Userid) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('pdfEditor/load', {params: {id: templateId, Userid},headers: {
      'content-type': 'application/json',
      'Authorization':   `Bearer ${jwt}`
  } }).then(({data}) => {
      dispatch({type: PDFEDITOR_ON_LOAD_TEMPLATE, payload: data})
      dispatch(checkPageSectionsTotalHeight())
    }).catch(err => {
      console.log(err)
    })
  }
}

export const setNewTemp = () => {
  // let newID = uuidv4()
  return (dispatch) => {
    dispatch({type: PDFEDITOR_ON_SET_NEW_TEMP})
  }
}

export const uploadImage = (file, Afid, limit = 1000000) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    const formData = new FormData()
    console.log(file)
    
    formData.append('files[]', file);
    formData.append('Afid', Afid)
    formData.append('limit', limit)

    axios.post('/pdfEditor/uploadImage', 
      formData,
      {
        body: {
          Afid,
          limit
        },
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization':   `Bearer ${jwt}`
        }
      }
    ).then(({data}) => {
      console.log(data)
      if(data.success){
        dispatch(getImageGallery(Afid))
        dispatch({type: PDFEDITOR_ON_RESPOSE, payload: {success: true, msg: 'Bild uppladdad!', show: true, type: 'success'}})
      } else {
        dispatch({type: PDFEDITOR_ON_RESPOSE, payload: {success: false, msg: data.error, show: true, type: 'error'}})
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
export const deleteImage = (FileId, FilePath, Afid) => {
  return (dispatch) => {
    
    const jwt =  JSON.parse(localStorage.token);
    axios.delete('pdfEditor/deleteImage', { params:{FileId, FilePath}, 
    headers: {'Authorization':   `Bearer ${jwt}`}})
    .then(({data}) => {
      console.log(data)
      if(data.success){
        dispatch(getImageGallery(Afid))
        dispatch({type: PDFEDITOR_ON_RESPOSE, payload: {success: true, msg: 'Bild borttagen!', show: true, type: 'warning'}})
      } else {
        dispatch({type: PDFEDITOR_ON_RESPOSE, payload: {success: false, msg: data.error, show: true, type: 'error'}})
      }
    }).catch(err => {
      console.log(err)
    })
  }
}

export const getImageGallery = (afId) => {
  return (dispatch) => {
    const jwt =  JSON.parse(localStorage.token);
    axios.get('pdfEditor/loadImages', {params: {Afid: afId}, headers: {'Authorization':   `Bearer ${jwt}`}}).then(({data}) => {
      dispatch({ type: PDFEDITOR_ON_LOAD_IMAGE_GALLERY, payload: data})
    }).catch(err => {
      console.log(err)
    })
  }
}

export const menuTabChange = (tab) => {
  return (dispatch) => {
      dispatch({ type: PDFEDITOR_ON_MENU_TAB_CHANGE, payload: tab})
  }
}

export const resetResponseDataPdfEditor = () => {
  return (dispatch) => {
    dispatch({ type: PDFEDITOR_ON_RESPOSE_RESET, payload: {}})
  }
}
//Jack
//AddnewMallBransch
export const AddnewMallBransch = (Kedja,Bransch,MallId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     //dispatch({type: ON_START_ADD_NEW_KONTO_MALL});
     axios.put('kontos/Mall/newBransch', {
      method: 'PUT',
      body: {
        Kedja:Kedja,
        Bransch:Bransch,
        MallId:MallId
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewMallBransch: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         //dispatch({type: ON_ADD_NEW_KONTO_MALL, payload: data.results});
         dispatch(getTemplates(Kedja))
       } else {
         //dispatch({type: ON_ERROR_ADD_NEW_KONTO_MALL, payload: data.error});
         dispatch(getTemplates(Kedja))
       }
     }).catch(function (error) {
       //dispatch({type: ON_ERROR_ADD_NEW_KONTO_MALL, payload: error.message});
       dispatch(getTemplates(Kedja))
       console.log("Error****:", error.message);
     });
   }
 } 
//AddnewMallKonto
export const AddnewMallKonto = (Kedja,Afid,MallId) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     //dispatch({type: ON_START_ADD_NEW_KONTO_MALL});
     axios.put('kontos/Mall/newKonto', {
      method: 'PUT',
      body: {
        Kedja:Kedja,
        Afid:Afid,
        MallId:MallId
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("AddnewMallKonto: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         //dispatch({type: ON_ADD_NEW_KONTO_MALL, payload: data.results});
         dispatch(getTemplates(Kedja))
       } else {
         //dispatch({type: ON_ERROR_ADD_NEW_KONTO_MALL, payload: data.error});
         dispatch(getTemplates(Kedja))
       }
     }).catch(function (error) {
       //dispatch({type: ON_ERROR_ADD_NEW_KONTO_MALL, payload: error.message});
       dispatch(getTemplates(Kedja))
       console.log("Error****:", error.message);
     });
   }
 } 
//deletethisMallKonto
export const deletethisMallKonto = (chip,Kedja) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     //dispatch({type: ON_START_ADD_NEW_KONTO_MALL});
     axios.put('kontos/Mall/deleteKonto', {
      method: 'PUT',
      body: {
        chip:chip,
        Kedja:Kedja,
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deletethisMallKonto: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         //dispatch({type: ON_ADD_NEW_KONTO_MALL, payload: data.results});
         dispatch(getTemplates(Kedja))
       } else {
         //dispatch({type: ON_ERROR_ADD_NEW_KONTO_MALL, payload: data.error});
         dispatch(getTemplates(Kedja))
       }
     }).catch(function (error) {
       //dispatch({type: ON_ERROR_ADD_NEW_KONTO_MALL, payload: error.message});
       dispatch(getTemplates(Kedja))
       console.log("Error****:", error.message);
     });
   }
 } 
//deletethisMallBransch
export const deletethisMallBransch = (chip,Kedja) =>{
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     //dispatch({type: ON_START_ADD_NEW_KONTO_MALL});
     axios.put('kontos/Mall/deleteBransch', {
      method: 'PUT',
      body: {
        chip:chip,
        Kedja:Kedja,
      },
    },{
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      }       
  }).then(({data}) => {
      console.log("deletethisMallBransch: ", data);
       if (data.results) {
        // dispatch({type: FETCH_ALL_CONTACT});
         //dispatch({type: ON_ADD_NEW_KONTO_MALL, payload: data.results});
         dispatch(getTemplates(Kedja))
       } else {
         //dispatch({type: ON_ERROR_ADD_NEW_KONTO_MALL, payload: data.error});
         dispatch(getTemplates(Kedja))
       }
     }).catch(function (error) {
       //dispatch({type: ON_ERROR_ADD_NEW_KONTO_MALL, payload: error.message});
       dispatch(getTemplates(Kedja))
       console.log("Error****:", error.message);
     });
   }
 } 
